import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


const requestOptions = { headers: { 'Content-Type': 'application/json' } };

@Injectable()
export class CommonService {

  formal = new BehaviorSubject(true);
  public LoggedInUserObs$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(private httpClient: HttpClient) { }

  getLoggedInUserObs(): Observable<any> {
    return this.LoggedInUserObs$.asObservable();
  }

  setLoggedInUserObs(userEmail: any) {
    this.LoggedInUserObs$.next(userEmail);
  }

  getUserRoles(): Observable<any> {
    return this.httpClient.get(environment.APIEndpoint + 'api/Common/GetUserRoles')
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getEngagementContactDetails(engagementId: number): Observable<any> {
    return this.httpClient.get(environment.APIEndpoint + 'api/Common/GetEngagementContact?engagementId=' + engagementId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getEngagementRoles(languageId: number): Observable<any> {
    return this.httpClient.get(environment.APIEndpoint + 'api/Common/GetEngagementRoleDropDown?languageId=' + languageId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getStatus(): Observable<any> {
    return this.httpClient.get(environment.APIEndpoint + 'api/Common/GetStatus')
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  deleteInternalUser(engagementInternalContactId: number): Observable<any> {
    return this.httpClient.delete(environment.APIEndpoint + 'api/Common/DeleteInternalContact?engagementInternalContactId=' + engagementInternalContactId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  saveOrUpdateInternalUser(internalUserModel: any): Observable<any> {
    return this.httpClient.post(environment.APIEndpoint + 'api/Common/SaveOrUpdateEnagegmentInternalContact', internalUserModel)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  saveExternalRoles(rolesModel: any): Observable<any> {
    return this.httpClient.post(environment.APIEndpoint + 'api/Common/SaveEngagementRoles', rolesModel)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  updateExternalRoles(rolesModel: any): Observable<any> {
    return this.httpClient.post(environment.APIEndpoint + 'api/Common/UpdateEngagementRoles', rolesModel)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }


  deleteExternalRole(externalRoleId: number): Observable<any> {
    return this.httpClient.delete(environment.APIEndpoint + 'api/Common/DeleteExternalRole?externalContactId=' + externalRoleId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  saveOrUpdateExternalContact(externalContactModel): Observable<any> {
    return this.httpClient.post(environment.APIEndpoint + 'api/Common/SaveOrUpdateExternalContact', externalContactModel)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  deleteExternalContact(externalContactId): Observable<any> {
    return this.httpClient.delete(environment.APIEndpoint + 'api/Common/DeleteExternalContact?externalContactId=' + externalContactId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  setTitle(title: boolean) {
    this.formal.next(title);
  }

  getUserApprovalCount() {
    return this.httpClient.get(environment.APIEndpoint + 'api/Common/GetApprovalAwaitingCount')
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  
  getPendingApprovalList(showAll:boolean): any {

    return this.httpClient.get(environment.APIEndpoint + 'api/Common/GetPendingApproval?showAll=' + showAll)
      .map((res: Response) => res)
      .catch(this.handleError);
  }

  private handleError(error: Response) {
    console.error(error);
    return throwError(error || 'Server error');
  }

  getEngagementInternalContactHistory(engagementId: number) {
    return this.httpClient.get(environment.APIEndpoint + 'api/Common/GetInternalContactHistory?engagementId=' + engagementId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }
}




